import styled from 'styled-components';
import { colors } from '../../styles/variables';

const StyledInput = styled.input`
  width: 100%;
  height: 40px;
  background-color: transparent;
  font-size: 16px;
  padding: 4px 16px;
  border: 1px solid ${colors.gray300};
  -moz-border-radius: 0;
  -webkit-border-radius: 0;
  -webkit-appearance: none;
  border-radius: 0;
  outline: none;
  &::placeholder {
    color: ${colors.gray500};
  }
`;

export const Input = ({type, ...props}) => {
  return (
    <StyledInput type={type} {...props} />
  )
}